import React from 'react';

const services = [
  {
    title: 'Celebrity Contact for Event',
    image: '/celebrities.jpeg',
    desc: 'Connect with celebrities and influencers for brand endorsements, launches, and event appearances.'
  },
  {
    title: 'Balloon Decoration',
    image: '/balloon.jpg',
    desc: 'Creative balloon decorations for birthdays, parties, and corporate events with unique themes.'
  },
  {
    title: 'Cake',
    image: '/cake.png',
    desc: 'Customized cakes for all occasions, designed and delivered fresh to your celebration.'
  },
  {
    title: 'Flower Decor',
    image: '/flower.jpg',
    desc: 'Elegant floral arrangements and decorations to add beauty and freshness to any event.'
  },
  {
    title: 'Sounds & Lights',
    image: '/sound-lights.png',
    desc: 'Professional sound and lighting setup for events, parties, and stage performances.'
  },
  {
    title: 'Photo & Video',
    image: '/photo-video.jpg',
    desc: 'Expert photography and videography services capturing every memorable moment of your event.'
  },
  {
    title: 'Stage & Floor',
    image: '/Florring.png',
    desc: 'Stylish stage and flooring setup designed for weddings, conferences, and corporate events.'
  },
  {
    title: 'Food Catering Services',
    image: '/catering.jpg',
    desc: 'Delicious and hygienic catering with customizable menus for events of all sizes.'
  },
  {
    title: 'Stage Flooring',
    image: '/stage.png',
    desc: 'Durable and elegant stage flooring installations suitable for events, exhibitions, and weddings.'
  },
  {
    title: 'Wedding Events',
    image: '/wedding.jpg',
    desc: 'End-to-end wedding event planning with decoration, catering, photography, and guest management.'
  },
  {
    title: 'Corporate Event & Planner',
    image: '/corporate.jpg',
    desc: 'Professional corporate event planning, from conferences to annual celebrations, managed flawlessly.'
  },
  {
    title: 'Bouncers & Bodyguards',
    image: '/security.png',
    desc: 'Trained security bouncers and personal bodyguards ensuring safety and discipline at every event.'
  },
];

const Services = () => (
  <section id="services" className="py-16 md:py-24 bg-gradient-to-br from-gray-50 to-white relative overflow-hidden">
    {/* Background Decorative Elements */}
    <div className="absolute top-0 right-0 w-96 h-96 bg-orange-100 rounded-full blur-3xl opacity-30 -z-10"></div>
    <div className="absolute bottom-0 left-0 w-96 h-96 bg-[#b8d4d4] rounded-full blur-3xl opacity-30 -z-10"></div>

    <div className="container mx-auto px-6">
      {/* Header Section */}
      <div className="text-center max-w-3xl mx-auto mb-16">
        <p className="text-lg text-gray-600 mb-3 tracking-wide" style={{ fontFamily: "'Hepta Slab', serif" }}>
          What We Offer Under
        </p>
        <div className="inline-block">
          <h2 className="text-5xl md:text-6xl font-black text-gray-900 mb-4" style={{ fontFamily: "'Diplomata', 'Arbutus', cursive" }}>
            Event Services
          </h2>
          <div className="w-full h-2 bg-gradient-to-r from-orange-500 via-[#b8d4d4] to-orange-500 rounded-full mb-8"></div>
        </div>
        <p className="text-xl text-gray-700 leading-relaxed" style={{ fontFamily: "'Hepta Slab', serif" }}>
          From concept to completion, we focus on creating memorable experiences that leave a lasting impression. 
          Whatever your event need, we bring professionalism, creativity, and perfect execution.
        </p>
      </div>

      {/* Services Grid */}
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 max-w-7xl mx-auto">
        {services.map((service, idx) => (
          <div
            key={idx}
            className="group bg-white rounded-3xl shadow-xl hover:shadow-2xl transition-all duration-500 transform hover:-translate-y-3 overflow-hidden border-2 border-transparent hover:border-orange-300"
          >
            {/* Image Container */}
            <div className="relative h-64 overflow-hidden bg-gradient-to-br from-gray-100 to-gray-200">
              <img 
                src={service.image}
                alt={service.title}
                className="w-full h-full object-cover transform group-hover:scale-110 transition-transform duration-700"
              />
              {/* Gradient Overlay */}
              <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-black/20 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-500"></div>
              
              {/* Floating Badge */}
              <div className="absolute top-4 right-4 bg-orange-500 text-white px-4 py-2 rounded-full text-sm font-bold shadow-lg transform translate-x-20 group-hover:translate-x-0 transition-transform duration-500" style={{ fontFamily: "'Hepta Slab', serif" }}>
                Premium
              </div>
            </div>

            {/* Content Container */}
            <div className="p-6 bg-white">
              {/* Title */}
              <h3 className="text-2xl font-black text-gray-900 mb-4 group-hover:text-orange-600 transition-colors duration-300" style={{ fontFamily: "'Diplomata', 'Arbutus', cursive" }}>
                {service.title}
              </h3>

              {/* Decorative Line */}
              <div className="w-16 h-1 bg-[#b8d4d4] mb-4 group-hover:w-full transition-all duration-500"></div>

              {/* Description */}
              <p className="text-gray-600 leading-relaxed text-base" style={{ fontFamily: "'Hepta Slab', serif" }}>
                {service.desc}
              </p>
            </div>
          </div>
        ))}
      </div>
    </div>
  </section>
);

export default Services;